import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

import { findIndex, has, isEqual } from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { WorkShiftsService } from '../../../../work-shifts.service';
import { ConfirmModalComponent } from '../../../../../../shared/modals/confirm-modal/confirm-modal.component';
import { Enums } from '../../../../../../configs/Enums';
import { WorkShiftsTemplateFilterService } from '../../../work-shifts-template-filter/work-shifts-template-filter.service';
import { AuthService } from '../../../../../auth/auth.service';
import { SelectComponent } from '../../../../../../ui/select/select.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'work-shift-cell-popover',
  templateUrl: './work-shift-cell-popover.component.html',
  styleUrls: ['./work-shift-cell-popover.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WorkShiftCellPopoverComponent implements OnInit, OnChanges {
  moment = require('moment');
  cellPopoverIsOpen = false;
  startWorkTime = { hour: 0, minute: 0 };
  endWorkTime = { hour: 0, minute: 0 };
  comment = null;
  commentDefault = null;
  isShowComment = false;
  isNotRelocation = false;
  workTypeSelected = null;
  workTypesData = null;
  workPlaceSelected = null;
  workPlacesList = [];
  cellError = null;
  cellLoading = false;
  cellTypesHighlight = {};
  cellHighlight = 0;
  cellSquare = {};
  popover;
  isPreviewCell = false;
  isFuncDisabled = false;
  timeValidationDisabled = false;
  title = '';
  isBlockedEditCreate: boolean;
  selectKey = 0; // Для принудительного обновления компонента select
  emptySchedule = {
    cell_type: null,
    commentary: '',
    int_begin: null,
    int_delta: 0,
    int_end: null,
    sector: null,
    sector_id: null,
  };

  @Input() filter;
  @Input() templateFilter;
  @Input() templateFilterData;
  @Input() user;
  @Input() cell;
  @Input() calendar;
  @Input() index;
  @Input() endIndex;
  @Input() isActiveTemplateFilterPreviewMode;
  @Input() previousCell;

  @ViewChild('workTypeSelect') selectComponent: SelectComponent;

  constructor(
    private workShiftsService: WorkShiftsService,
    public modalService: NgbModal,
    private authService: AuthService,
    private workShiftsTemplateFilterService: WorkShiftsTemplateFilterService,
    private cdr: ChangeDetectorRef
  ) {
    this.cellTypesHighlight[1] = 'blue-light';
    this.cellTypesHighlight[2] = 'orange-light';
    this.cellTypesHighlight[3] = 'pink-light';
    this.cellTypesHighlight[4] = 'gray-pale';
    this.cellTypesHighlight[5] = 'gray-pale';
    this.cellTypesHighlight[6] = 'pink-light';
    this.cellTypesHighlight[7] = 'gray-bright-light';
    this.cellTypesHighlight[8] = 'gray-pale';
    this.cellTypesHighlight[9] = 'green-light';

    this.cellSquare[1] = 'blue-light';
    this.cellSquare[2] = 'orange-light';
    this.cellSquare[3] = 'pink-light';
    this.cellSquare[4] = 'gray-pale';
    this.cellSquare[5] = 'gray-pale';
    this.cellSquare[6] = 'pink-light';
    this.cellSquare[7] = 'gray-bright-light';
    this.cellSquare[8] = 'gray-pale';
    this.cellSquare[9] = 'green-light';

    this.isBlockedEditCreate = !this.authService.checkPermission('schedule.edit');

    if (this.isBlockedEditCreate) {
      this.cellError = Enums.errorCodes[200000];
    }
  }

  get isGRS() {
    return this.authService.isGRSUser();
  }

  isShown(date: string) {
    if (!date) {
      return;
    }
    return this.moment(this.cell.workday, 'YYYY-MM-DD').isSame(this.moment(date, 'YYYY-MM-DD'), 'day');
  }

  getDelta(cell) {
    return cell.schedule_preview ? (cell.schedule_preview && cell.schedule_preview.int_delta) || 0 : (cell.schedule && cell.schedule.int_delta) || 0;
  }

  getEndTime(intEnd, prevIntEnd) {
    if (this.isShown(intEnd)) {
      return intEnd;
    }

    if (this.isShown(prevIntEnd)) {
      return prevIntEnd;
    }

    return '';
  }

  isTemplate(cell) {
    return Boolean(cell.schedule_preview);
  }

  isDisabled() {
    return (
      (!this.isPreviewCell && this.templateFilter.isActiveTemplateFilter) ||
      this.cell.relocation ||
      (this.isPreviewCell && this.templateFilter.isActiveTemplateFilter) ||
      this.cell.relocation
    );
  }

  ngOnInit() {
    let cell = this.cell;

    this.initUiData();
    this.isPreviewCell =
      this.cell.workday <
      this.moment(this.calendar.current_date)
        .add(-(this.calendar.editable_within_days - 1), 'day')
        .format('YYYY-MM-DD');

    // В режиме точечного редактирования, у прикомандированного монтажника в селекте "Вид затрат времени"
    // не должно быть вариант "Командировка"
    this.isNotRelocation = cell.schedule && cell.schedule.sector && cell.schedule.sector.sector_id !== this.filter.plotSelected.sector_id;
    this.makeDopData();

    if (!cell.schedule) {
      this.workTypesData = this.templateFilterData.cellTypesList;
    } else {
      if (!cell.schedule.sector) {
        this.workTypesData = this.templateFilterData.cellTypesList;
      } else {
        if (cell.schedule.sector && cell.schedule.sector.sector_id !== this.filter.plotSelected.sector_id) {
          this.workTypesData = this.templateFilterData.cellTypesList;
        } else {
          this.workTypesData = this.templateFilterData.cellTypesListWithOutRelacation;
        }
      }
    }

    if (this.templateFilterData.workPlacesList && this.templateFilterData.workPlacesList.length) {
      this.workPlacesList = this.templateFilterData.workPlacesList.filter((place) => {
        return place.sector_id !== this.filter.plotSelected.sector_id;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.isActiveTemplateFilterPreviewMode) {
      this.makeDopData();
    }
  }

  makeDopData() {
    let cell = this.cell;
    if (this.isActiveTemplateFilterPreviewMode) {
      if (this.cell && this.cell.schedule_preview) {
        this.makePreviewHighlight();
        this.makePreviewTitle();
      }
    } else {
      if (cell.relocation) {
        this.cellHighlight = 0;
        return;
      }

      this.makeHighlightAndTitle();
    }
  }

  makePreviewHighlight() {
    let cell = this.cell;

    this.cellHighlight = cell.schedule_preview && cell.schedule_preview.cell_type && cell.schedule_preview.cell_type.ct_id;
  }

  makePreviewTitle() {
    let cell = this.cell;

    this.title = cell.schedule_preview && cell.schedule_preview.cell_type && cell.schedule_preview.cell_type.ct_name;
  }

  getIntBegin(cell) {
    if (!cell) {
      return null;
    }
    return cell.schedule_preview ? cell.schedule_preview.int_begin : cell.schedule ? cell.schedule.int_begin : null;
  }

  getIntEnd(cell) {
    if (!cell) {
      return null;
    }
    return cell.schedule_preview ? cell.schedule_preview.int_end : cell.schedule ? cell.schedule.int_end : null;
  }

  isWorkingDay(cell) {
    return cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id === 1;
  }

  isScheduleEmpty(cell) {
    return cell && (!cell.schedule || (!this.getIntBegin(cell) && !this.getIntEnd(cell)));
  }

  endsNextDay(previousCell) {
    if (!previousCell) {
      return;
    }

    const nextDay = this.moment(previousCell.workday, 'YYYY-MM-DD').add(1, 'day');
    return this.getIntEnd(previousCell) && nextDay.isSame(this.moment(this.getIntEnd(previousCell)), 'day');
  }

  makeHighlightAndTitle() {
    let cell = this.cell;

    // Если нет расписания вообще, устанавливаем значения по умолчанию
    if (!cell.schedule) {
      this.cellHighlight = 0;
      this.title = '';
      return;
    }

    if (cell.schedule && cell.schedule.sector) {
      if (cell.schedule.sector.sector_id === this.filter.plotSelected.sector_id) {
        if (cell.schedule.cell_type && cell.schedule.cell_type.ct_id === 2) {
          this.cellHighlight = 9;
          this.title = 'Командировка';
        } else {
          this.cellHighlight = cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id;
          this.title = cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_name;
        }
      } else {
        // Исправляем: используем актуальный тип ячейки вместо hardcoded "Командировка"
        this.cellHighlight = cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id;
        this.title = cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_name;
      }
    } else {
      // Случай когда нет сектора или schedule вообще нет
      this.cellHighlight = cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id;
      this.title = cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_name;
    }
  }

  initUiData() {
    let cell = this.cell;
    let cellId = 1;
    let indexCellType;
    let placeSelected;
    let isInitTime = false;
    this.timeValidationDisabled = false;

    // Принудительно сбрасываем предыдущие значения для предотвращения "залипания"
    this.workTypeSelected = null;
    this.workPlaceSelected = null;
    this.comment = null;
    this.isShowComment = false;
    this.title = '';

    // Также сбрасываем relocation при инициализации UI
    if (cell) {
      cell.relocation = false;
    }

    if (cell.schedule && cell.schedule.cell_type) {
      this.comment = cell.schedule.commentary;
      // this.initTime();
    }

    if (cell.schedule && cell.schedule.commentary) {
      this.commentDefault = cell.schedule.commentary;
    }

    if (!cell.schedule) {
      indexCellType = findIndex(this.templateFilterData.cellTypesList, {
        ct_id: 1,
      });

      this.initTime();
    } else {
      if (cell.schedule && cell.schedule.sector) {
        if (cell.schedule.sector.sector_id === this.filter.plotSelected.sector_id) {
          if (cell.schedule.cell_type && cell.schedule.cell_type.ct_id === 2) {
            indexCellType = findIndex(this.templateFilterData.cellTypesList, {
              ct_id: 1,
            });
            isInitTime = true;
            // this.initTime();
          } else {
            indexCellType = findIndex(this.templateFilterData.cellTypesList, {
              ct_id: cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id,
            });
            isInitTime = true;
            // this.initTime();
          }
        } else {
          // Исправляем: используем реальный тип ячейки, а не принудительно ct_id: 2
          indexCellType = findIndex(this.templateFilterData.cellTypesList, {
            ct_id: cell.schedule.cell_type.ct_id,
          });

          // Только если это действительно командировка (ct_id: 2), устанавливаем место работы
          if (cell.schedule.cell_type.ct_id === 2) {
            placeSelected = findIndex(this.templateFilterData.workPlacesList, {
              sector_id: cell.schedule.sector.sector_id,
            });
          }

          isInitTime = true;
        }
      } else {
        indexCellType = findIndex(this.templateFilterData.cellTypesList, {
          ct_id: cell.schedule && cell.schedule.cell_type && cell.schedule.cell_type.ct_id,
        });
        isInitTime = true;
        // this.initTime();
      }
    }

    if (indexCellType > -1) {
      this.workTypeSelected = this.templateFilterData.cellTypesList[indexCellType];

      if (isInitTime) {
        this.initTime();
      }
    }

    if (placeSelected > -1) {
      this.workPlaceSelected = this.templateFilterData.workPlacesList[placeSelected];
    }

    if (this.templateFilter.type === 'planedTemplateFilter' && this.calendar.planned_schedule_fixed) {
      this.isFuncDisabled = true;
    }
  }

  initTime() {
    let cell = this.cell;

    this.startWorkTime.hour = cell.schedule && cell.schedule.int_begin ? +this.moment(cell.schedule.int_begin).format('H') : 0;
    this.startWorkTime.minute = cell.schedule && cell.schedule.int_begin ? +this.moment(cell.schedule.int_begin).format('mm') : 0;
    this.endWorkTime.hour = cell.schedule && cell.schedule.int_begin ? +this.moment(cell.schedule.int_end).format('H') : 0;
    this.endWorkTime.minute = cell.schedule && cell.schedule.int_begin ? +this.moment(cell.schedule.int_end).format('mm') : 0;

    if (cell.schedule && cell.schedule.sector) {
      if (cell.schedule.sector.sector_id === this.filter.plotSelected.sector_id) {
        if (cell && has(cell, 'schedule.cell_type.ct_id') && cell.schedule.cell_type.ct_id === 1) {
          this.onCheckTimeValidation();
        } else {
          if (this.workTypeSelected && this.workTypeSelected.ct_id && this.workTypeSelected.ct_id === 1) {
            this.onCheckTimeValidation();
          }
        }
      }
    } else {
      if (cell && has(cell, 'schedule.cell_type.ct_id') && cell.schedule.cell_type.ct_id === 1) {
        this.onCheckTimeValidation();
      } else {
        if (this.workTypeSelected && this.workTypeSelected.ct_id && this.workTypeSelected.ct_id === 1) {
          this.onCheckTimeValidation();
        }
      }
    }
  }

  checkDropComment() {
    const schedule = this.cell.schedule;
    const workTypeSelected = this.workTypeSelected;

    if (schedule && schedule.commentary && (workTypeSelected && workTypeSelected.ct_id) !== (schedule && schedule.cell_type && schedule.cell_type.ct_id)) {
      this.comment = null;
    } else {
      this.comment = this.commentDefault;
    }
  }

  toggleWithCell(popover) {
    this.popover = popover;
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onOpenEditConfirmDialog(popover) {
    if (!popover.isOpen() && !this.isScheduleEmpty(this.cell)) {
      if (this.templateFilter.type === 'planedTemplateFilter' && this.calendar.planned_schedule_fixed) {
        this.toggleWithCell(popover);
        return;
      }

      const editConfirmDialog = this.modalService.open(ConfirmModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-wrapper',
        backdrop: 'static',
      });

      editConfirmDialog.componentInstance.title = 'Подтвердите изменение графика';
      editConfirmDialog.componentInstance.description = 'На выбранные даты уже назначены смены. Вы действительно' + ' хотите перезаписать текущие данные?';
      editConfirmDialog.componentInstance.successButtonName = 'Да, перезаписать';
      editConfirmDialog.componentInstance.abortButtonName = 'Отмена';
      editConfirmDialog.result.then(
        () => {
          this.toggleWithCell(popover);
        },
        () => {}
      );
    } else {
      this.toggleWithCell(popover);
    }
  }

  showCell() {
    this.initUiData();
    this.makeDopData();

    this.cellPopoverIsOpen = true;
  }

  hideCell() {
    this.cellPopoverIsOpen = false;

    // Сбрасываем состояние при закрытии popover, но НЕ title
    // title должен оставаться для корректного отображения tooltip при наведении
    this.workTypeSelected = null;
    this.workPlaceSelected = null;
    this.comment = null;
    this.isShowComment = false;
    this.cellError = null;
    // НЕ сбрасываем this.title - он нужен для tooltip
  }

  onChangeTemplateWorkType(workTypeSelected) {
    this.cellError = null;
    this.workTypeSelected = workTypeSelected || null;
    this.checkDropComment();

    if (workTypeSelected && workTypeSelected.ct_id === 1) {
      this.onCheckTimeValidation();
    } else {
      this.timeValidationDisabled = false;
    }
  }

  onChangeStartTemplatePeriodTime(time) {
    this.startWorkTime = time;
    this.onCheckTimeValidation();
  }

  onChangeEndTemplatePeriodTime(time) {
    this.endWorkTime = time;
    this.onCheckTimeValidation();
  }

  onCheckTimeValidation() {
    let startTime = this.startWorkTime;
    let endTime = this.endWorkTime;
    let startPeriod = (startTime.hour ? startTime.hour * 60 * 1000 : 0) + (startTime.minute ? startTime.minute * 1000 : 0);
    let endPeriod = (endTime.hour ? endTime.hour * 60 * 1000 : 0) + (endTime.minute ? endTime.minute * 1000 : 0);

    const endsOnNextDay = this.getIntEnd(this.previousCell) && this.moment(this.getIntEnd(this.previousCell)).isSame(this.moment(this.cell.workday), 'day');

    if (this.authService.isGRSUser()) {
      this.timeValidationDisabled = endsOnNextDay && this.moment(this.previousCell.schedule.int_end).hours() > startTime.hour;
    } else {
      this.timeValidationDisabled = startPeriod > endPeriod;
    }
  }

  onChangeTemplateWorkPlace(selected) {
    this.workPlaceSelected = selected;
  }

  onShowComment() {
    this.isShowComment = true;
  }

  clearCell = (cell) => {
    cell.schedule = {
      cell_type: null,
      commentary: '',
      int_begin: null,
      int_end: null,
      sector: null,
      sector_id: null,
    } as any;
  };

  onSaveCellData(isReset) {
    const workTypeSelectedId = (this.workTypeSelected && this.workTypeSelected.ct_id) || 0;
    const selectedEntities = {
      weekend:
        this.templateFilterData.cellTypesList[
          findIndex(this.templateFilterData.cellTypesList, {
            ct_id: 8,
          })
        ],
      workTypeSelected: this.workTypeSelected,
      cellTypeSelected: null,
      comment: this.comment,
      startWorkTime: this.startWorkTime,
      endWorkTime: this.endWorkTime,
      workPlaceSelected: workTypeSelectedId === 2 ? this.workPlaceSelected : null,
    };
    const requestObj = {
      single_creation: true,
      cells: null,
    };

    this.cellError = null;

    switch (workTypeSelectedId) {
      case 1:
        if (!this.startWorkTime.hour && !this.startWorkTime.minute && !this.endWorkTime.hour && !this.endWorkTime.minute) {
          this.cellError = 'Поле “Время смены” обязательно для заполнения.';
        }
        break;
      case 2:
        if (!this.workPlaceSelected) {
          this.cellError = 'Поле “Временное место работы” обязательно для заполнения.';
        }
        break;
      default:
        break;
    }

    if (this.cellError) {
      return;
    }

    const cell = this.workShiftsTemplateFilterService.makeCell(this.cell, this.user, selectedEntities, null);

    if (!this.isNotRelocation) {
      if (isReset) {
        this.clearCell(cell);
      } else {
        // Правильно устанавливаем sector только для командировки (ct_id: 2)
        if (workTypeSelectedId === 2 && this.workPlaceSelected) {
          // Для командировки отправляем только sector_id как требует backend
          cell.schedule.sector = this.workPlaceSelected.sector_id;
        } else if (workTypeSelectedId !== 2) {
          // Для всех остальных типов кроме командировки убираем sector
          cell.schedule.sector = null;
        }
      }
    } else {
      if (isReset) {
        cell.schedule = {
          cell_type: null,
          commentary: '',
          int_begin: null,
          int_end: null,
          sector: null,
          sector_id: null,
        } as any;
      }
    }

    requestObj.cells = [cell];

    this.cellLoading = true;
    this.workShiftsService.saveOrEditCells(requestObj).subscribe(
      (response) => {
        this.cell.ws_id = response['data'].schedule.ws_id;
        const schedule = response['data'].schedule.schedule;

        this.cell.schedule = this.workShiftsService.retrieveSchedule(schedule);

        // Всегда сбрасываем relocation при обновлении ячейки
        this.cell.relocation = false;

        // Если ячейка была очищена (schedule стал null), сбрасываем все связанные данные
        if (!this.cell.schedule) {
          this.title = '';
          this.cellHighlight = 0;
          this.cell.relocation = false;
        }

        this.user.working_shift = this.workShiftsService.updateWorkingShift(this.user.working_shift, this.cell);
        this.user.working_shift = this.workShiftsService.formatWorkingShift(this.user.working_shift);

        this.cellLoading = false;
        this.commentDefault = null;
        this.user.milis_worked_total = response['data'].milis_worked_total;
        this.user.milis_worked_total = response['data'].milis_worked_total;

        // Принудительно обновляем данные ячейки из обновленного массива
        const updatedCell = this.user.working_shift.find((shift) => this.workShiftsService.moment(shift.workday).isSame(this.cell.workday));
        if (updatedCell) {
          Object.assign(this.cell, updatedCell);
          // Убеждаемся, что relocation сброшен и после обновления из массива
          this.cell.relocation = false;
        }

        // Обновляем отображение данных ячейки
        this.makeDopData();

        // Обновление UI
        this.cdr.markForCheck();
        this.cdr.detectChanges();

        // Закрываем popover после обновления всех данных
        this.onCloseCell();
      },
      (error) => {
        this.cellError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
        this.cellLoading = false;
      }
    );
  }

  onCloseCell() {
    // Сбрасываем только состояние формы перед закрытием, но НЕ title
    // title должен оставаться для корректного отображения tooltip при наведении
    this.workTypeSelected = null;
    this.workPlaceSelected = null;
    this.comment = null;
    this.isShowComment = false;
    this.cellError = null;
    // НЕ сбрасываем this.title - он нужен для tooltip

    this.popover.close();
    this.popover = null;
  }
}
